module.exports = __webpack_public_path__ + "media/src/images/photos/glasses-51b8292fa4e8901f5442e6eaec746396.jpg";